import page from './page'
import stroke from './stroke'
import stroke2 from './stroke2'
import copybook from './copybook'
import pinyinBook from './pinyin-book'
import pinyinLine from './pinyin-line'
import appList from './app-list'
import result from './result'
import mpFollowAd from './mp-follow-ad'

export default {
    install: function (Vue) {
        Vue.component('my-page', page)
        Vue.component('copybook', copybook)
        Vue.component('pinyin-book', pinyinBook)
        Vue.component('pinyin-line', pinyinLine)
        Vue.component('stroke', stroke)
        Vue.component('stroke2', stroke2)
        Vue.component('app-list', appList)
        Vue.component('result', result)
        Vue.component('yunser-mp-ad', mpFollowAd)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js